import React, { useEffect } from "react";
import PropTypes from "prop-types";

export const Checkbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    if (resolvedRef.current) {
      resolvedRef.current.indeterminate = indeterminate;
    }
  }, [resolvedRef, indeterminate]);

  return (
    <input type="checkbox" className="checkbox" ref={resolvedRef} {...rest} />
  );
});

Checkbox.displayName = "Checkbox";

Checkbox.propTypes = {
  indeterminate: PropTypes.bool
};
